
export default (() => {
  const walkableProps = 'id\n'
    + 'elementType\n';

  const pathwaysWithWalkable = 'pathways {'
+ 'id\n'
+ 'walkables {\n'
+ 'edges {\n'
+ 'node {\n'
+ `${walkableProps}`
+ '}\n'
+ '}\n'
+ '}\n'
+ '}\n';

  const attempt = 'attempt {'
+ 'id\n'
+ 'value\n'
+ '}\n';

  const progress = 'progress {'
+ 'completion {\n'
+ 'value\n'
+ 'confidence\n'
+ '}\n'
+ '}\n';

  const score = 'score {'
+ 'value\n'
+ '}';

  const scope = 'scope {'
+ 'data\n'
+ 'scopeURN\n'
+ 'sourceId\n'
+ '}\n';

  const Activity = `${walkableProps}`
+ `${pathwaysWithWalkable}`
+ `${attempt}`
+ `${progress}`
+ `${score}`
+ `${scope}`;

  const Interactive = `${walkableProps}`
+ `${attempt}`
+ `${progress}`
+ `${scope}`;

  const learnerDataLesson = (cohortId, deploymentId, lessonId, screenId) => {
    const query = `${'{'
      + ' learn {'
      + ' cohort(cohortId: "'}${cohortId}") {`
      + ` deployment(deploymentId: "${deploymentId}") {`
      + `activity(activityId: "${lessonId}") {`
      + `${Activity}`
      + '}'
      + `interactive(interactiveId: "${screenId}") {`
      + `${Interactive}`
      + '}'
      + '}'
      + '}'
      + '}'
      + '}';
    return query;
  };

  const learnerDataCourseWithoutInteractive = (cohortId, deploymentId, courseId, unitId, lessonId) => {
    const query = `${'{'
    + ' learn {'
    + ' cohort(cohortId: "'}${cohortId}") {`
    + ` deployment(deploymentId: "${deploymentId}") {`
    + `course : activity(activityId: "${courseId}") {`
    + `${Activity}`
    + '}'
    + `unit : activity(activityId: "${unitId}") {`
    + `${Activity}`
    + '}'
    + `activity(activityId: "${lessonId}") {`
    + `${Activity}`
    + '}'
    + '}'
    + '}'
    + '}'
    + '}';
    return query;
  };

  const learnerDataFull = (cohortId, deploymentId, courseId, unitId, lessonId, screenId) => {
    const query = `${'{'
    + ' learn {'
    + ' cohort(cohortId: "'}${cohortId}") {`
    + ` deployment(deploymentId: "${deploymentId}") {`
    + `course : activity(activityId: "${courseId}") {`
    + `${Activity}`
    + '}'
    + `unit : activity(activityId: "${unitId}") {`
    + `${Activity}`
    + '}'
    + `activity(activityId: "${lessonId}") {`
    + `${Activity}`
    + '}'
    + `interactive(interactiveId: "${screenId}") {`
    + `${Interactive}`
    + '}'
    + '}'
    + '}'
    + '}'
    + '}';
    return query;
  };
  return {
    learnerDataLesson,
    learnerDataCourseWithoutInteractive,
    learnerDataFull,
  };
})();
